
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    totalesCentros: null,
    totalCentros: 0,


    startLimpiarTotalesCentos: () => {
        set({ totalesCentros: null });
    },
    
});





export const useCentroCostoStore = create()(
    devtools(
        storeApi
    )
)
